import { IValidatedQuestion } from '@sdk/contracts';
import { create } from 'zustand';

interface IStore {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedQuestion?: IValidatedQuestion;
  setSelectedQuestion: (question?: IValidatedQuestion) => void;
}

const store = create<IStore>(set => ({
  isOpen: false,
  setIsOpen: isOpen => set({ isOpen }),
  selectedQuestion: undefined,
  setSelectedQuestion: question => set({ selectedQuestion: question })
}));

export const useQuestionForm = () => {
  const { isOpen, setIsOpen, selectedQuestion, setSelectedQuestion } = store();

  return { isOpen, setIsOpen, selectedQuestion, setSelectedQuestion };
};
